import { ChangeDetectorRef, Component, EventEmitter, Input, Output } from '@angular/core';
import { Router } from '@angular/router';
import { Subject, takeUntil } from 'rxjs';
import { CustomerIdService } from 'src/app/services/feature/customerId/customer-id.service';

@Component({
  selector: 'kb-open-position-table',
  templateUrl: './kb-open-position-table.component.html',
  styleUrls: ['./kb-open-position-table.component.scss'],
  standalone: false
})
export class KbOpenPositionTableComponent {
  @Input() searchItemsList: any;
  @Input() soldOrderId: any;
  @Input() dateFormat: any;
  @Output() sortEvent = new EventEmitter<any>();
  @Output() pageEvent = new EventEmitter<any>();
  @Output() exportToExcel = new EventEmitter<any>();
  fleetPrideGroup: any;
  showNetPrice$ = this.custIDService.showNetPrice$;
  private destroy$ = new Subject<void>();
  constructor(public custIDService: CustomerIdService, private cdr: ChangeDetectorRef, private router: Router) { }

  ngOnInit() {
    this.custIDService.fleetPrideGroup$.pipe(takeUntil(this.destroy$)).subscribe((x) => {
      this.fleetPrideGroup = x;
      this.cdr.detectChanges();
    });
  }

  exportToExcelFile() {
    this.exportToExcel.emit(true);
  }

  postOpenPositionData(event) {
    this.pageEvent.emit(event);
  }

  sort(event) {
    this.sortEvent.emit(event);
  }

  redirectOrder(item) {
    const formattedRoute =
      item.orderCode + '-' + this.soldOrderId + '-' + item.placedFormat;
    this.router.navigate(['order'], {
      queryParams: { orderId: formattedRoute, position: true },
    });
  }

  formatDate(dateString: string, format?: string): string {
    const date = new Date(dateString);
    const day = this.padZero(date.getDate());
    const month = this.padZero(date.getMonth() + 1);
    const year = date.getFullYear();
    if (format) {
      return `${year}${month}${day}`;
    }
    return `${day}.${month}.${year}`;
  }

  padZero(value: number): string {
    return value < 10 ? '0' + value : value.toString();
  }
  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }

}
